var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmenttick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 29.25,
    height: 29.25,
    rx: 4.625,
    stroke: "#F0F1F2",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.465 9.40039L11.3288 20.6004L7.53271 16.7826",
    stroke: "#25C277",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmenttick);
export default __webpack_public_path__ + "static/media/Segmenttick.f7c0573228a8e170a86ce402a5376354.svg";
export { ForwardRef as ReactComponent };